import React from 'react';
import styles from "../../../../styles/office/EditModal.module.css";

const SurveyDetailsDialog = ({
  language,
  formData,
  onChange,
  onCancel,
  onGenerate
}) => (
  <div className={styles.confirmationOverlay}>
    <div className={styles.surveyDialogCard}>
      <div className={styles.surveyDialogHeader}>
        <h3>{language === 'en' ? 'Survey Information' : 'सर्वे माहिती'}</h3>
      </div>

      <div className={styles.surveyDialogBody}>
        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Name' : 'नाव'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={onChange}
            className={styles.surveyDialogInput}
            placeholder={language === 'en' ? 'Enter your name' : 'आपले नाव प्रविष्ट करा'}
          />
        </div>

        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Survey No.' : 'सर्वे नंबर'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="text"
            name="surveyNo"
            value={formData.surveyNo}
            onChange={onChange}
            className={styles.surveyDialogInput}
            placeholder={language === 'en' ? 'Enter survey number' : 'सर्वे नंबर प्रविष्ट करा'}
          />
        </div>

        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Village' : 'गाव'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="text"
            name="village"
            value={formData.village}
            onChange={onChange}
            className={styles.surveyDialogInput}
            placeholder={language === 'en' ? 'Enter village name' : 'गावाचे नाव प्रविष्ट करा'}
          />
        </div>

        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Email' : 'ईमेल'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={onChange}
            className={styles.surveyDialogInput}
            placeholder="example@email.com"
          />
        </div>

        <div className={styles.surveyDialogGroup}>
          <label>
            {language === 'en' ? 'Date' : 'तारीख'} <span className={styles.requiredIndicator}>*</span>
          </label>
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={onChange}
            className={styles.surveyDialogInput}
          />
        </div>
      </div>

      <div className={styles.surveyDialogActions}>
        <button onClick={onCancel} className={styles.surveyDialogCancel}>
          {language === 'en' ? 'Cancel' : 'रद्द करा'}
        </button>
        <button onClick={onGenerate} className={styles.surveyDialogGenerate}>
          {language === 'en' ? 'Confirm And Generate' : 'तयार करा'}
        </button>
      </div>
    </div>
  </div>
);

export default SurveyDetailsDialog;